import type { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import type { IconPropsT } from './Icon';
import Icon from './Icon';

const SaveIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill={theme.colors.primary.variant1}
        viewBox="0 -1 18 18"
      >
        <path d="M12 2h-2v3h2z" />
        <path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5V2.914a1.5 1.5 0 0 0-.44-1.06L14.147.439A1.5 1.5 0 0 0 13.086 0zM4 6a1 1 0 0 1-1-1V1h10v4a1 1 0 0 1-1 1zM3 9h10a1 1 0 0 1 1 1v5H2v-5a1 1 0 0 1 1-1" />
      </svg>
    </Icon>
  );
};

export default SaveIcon;
